import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { jqxSchedulerComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxscheduler';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { Afastamento } from '../_classes/afastamento';
import { Util } from '../_classes/util';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-afastamento',
  templateUrl: './afastamento.component.html',
  styleUrls: ['./afastamento.component.scss'],
})
export class AfastamentoComponent implements OnInit {
  private readonly recurso: string = 'afastamento'; //mesmo que a rota

  @ViewChild('schedulerReference', { static: true })
  scheduler: jqxSchedulerComponent;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = [
    'dtInicio',
    'totalDiasAfastamento',
    'dsGrupoAfastamento',
    'dsTipoAfastamento',
  ];

  listaAfastamentos: Afastamento[] = new Array<Afastamento>();

  source = {
    dataType: 'array',
    dataFields: [
      { name: 'id', type: 'string' },
      { name: 'description', type: 'string' },
      { name: 'location', type: 'string' },
      { name: 'subject', type: 'string' },
      { name: 'calendar', type: 'string' },
      { name: 'start', type: 'date' },
      { name: 'end', type: 'date' },
    ],
    id: 'id',
    localData: null, // this.generateAppointments2()
  };

  dataAdapter = new jqx.dataAdapter(this.source);

  schedulerSettings: jqwidgets.SchedulerOptions = {
    date: new jqx.date(2016, 11, 23),
    width: 800,
    height: 600,
    source: this.dataAdapter,
    view: 'monthView',
    showLegend: false,
    appointmentDataFields: {
      from: 'start',
      to: 'end',
      id: 'id',
      description: 'description',
      location: 'location',
      subject: 'subject',
      resourceId: 'calendar',
    },
    resources: {
      dataField: 'calendar',
      source: new jqx.dataAdapter(this.source),
    },
    views: ['monthView'],
  };

  localization = {
    firstDay: 0,
    days: {
      // full day names
      names: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      // abbreviated day names
      namesAbbr: ['Dom', 'Seg', 'Tern', 'Qua', 'Qui', 'Sex', 'Sáb'],
      // shortest day names
      namesShort: ['Dm', 'Sg', 'Tr', 'Qa', 'Qi', 'Sx', 'Sá'],
    },
    months: {
      // full month names (13 months for lunar calendards -- 13th month should be "" if not lunar)
      names: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
        '',
      ],
      // abbreviated month names
      namesAbbr: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
        '',
      ],
    },
  };

  carregando = false;

  dataSource$: Observable<Afastamento[]>;
  dataSource: MatTableDataSource<Afastamento>;

  listaItens: Array<string> = new Array<string>();
  listaClasse: Array<string> = new Array<string>();

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  //mostrarAjuda = false;
  itensAjuda = [
    { titulo: 'Período', texto: 'Período do afastamento' },
    { titulo: 'Dias', texto: 'Quantidade em dias' },
    { titulo: 'Tipo', texto: 'Tipo de afastamento' },
    {
      titulo: 'Detalhe',
      texto: 'Detalhes sobre aquele período de afastamento',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    //this.dataSource = new MatTableDataSource([]);
    //this.atualizarPaginador();
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  itemDaListaPelaClasse(classe: string) {
    return this.listaItens[
      this.listaClasse.indexOf(classe)
    ].toLocaleUpperCase();
  }

  estilo(se: Afastamento, outrasClasses: string) {
    return (
      outrasClasses +
      ' ' +
      this.listaClasse[this.listaItens.indexOf(se.dsGrupoAfastamento)]
    );
  }

  larguraDaTabela() {
    let numero: number;
    if (Util.larguraDaTela() > 600) {
      numero = 1100; //Util.larguraDaTela() - Util.larguraDaTela() / 5;
    } else {
      numero = Util.larguraDaTela() - Util.larguraDaTela() / 20;
    }
    //console.log('numero', numero);
    //console.log('div', this.div);
    return numero;
  }

  larguraDaTela() {
    //console.log(Util.larguraDaTela());
    return Util.larguraDaTela();
  }

  renderAppointment = (data) => {
    data.cssClass =
      this.listaClasse[
        this.listaItens.indexOf(data.appointment.originalData.calendar)
      ];
    data.background =
      this.listaClasse[
        this.listaItens.indexOf(data.appointment.originalData.calendar)
      ];
    data.textColor = 'white';
    data.borderColor = 'black';
    return data;
  };

  generateAppointments(): any {
    const appointments = new Array();

    this.listaItens = this.listaAfastamentos
      .map((item) => item.dsGrupoAfastamento)
      .filter((value, index, self) => self.indexOf(value) === index);

    let vI: number = 1;
    this.listaItens.forEach((x) => {
      const item = Util.estilo2(vI);
      if (vI + 3 > Util.COR.length) {
        vI = 1;
      } else {
        vI = vI + 3;
      }
      this.listaClasse.push(item);
    });

    this.listaAfastamentos.forEach((e: Afastamento) => {
      appointments.push({
        id: 'id' + e.idAfastamento,
        description: e.dsGrupoAfastamento + ' - ' + e.dsTipoAfastamento,
        subject: e.dsGrupoAfastamento + ' - ' + e.dsTipoAfastamento,
        calendar: e.dsGrupoAfastamento,
        start: e.dtInicio,
        end: e.dtFim,
        allDay: true,
        readOnly: true,
      });
    });

    return appointments;
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }
*/
  executarAoCarregarDatasource(x: Afastamento[]) {
    this.listaAfastamentos = x;
    this.dataSource = new MatTableDataSource<Afastamento>(x);

    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }

    this.carregarScheduler();
    this.carregando = false;
  }

  carregarScheduler() {
    this.schedulerSettings.source = new jqx.dataAdapter(
      (this.source.localData = this.generateAppointments())
    );
    this.schedulerSettings.date = new jqx.date('today');

    this.schedulerSettings.resources.source = new jqx.dataAdapter(this.source);

    this.scheduler.createComponent(this.schedulerSettings);
    this.scheduler.ensureAppointmentVisible('id1');
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarAfastamento(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  periodo(a: Afastamento): string {
    return Util.periodo(a.dtInicio, a.dtFim);
  }

  aplicarFiltro(evento: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  alterarLoading() {
    this.carregando = !this.carregando;
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
